<!-- <div
    class="section-gap pb-0 pt-5 image-group"
    [ngClass]="{ blockView: environmentVariables?.GROUP_MOBILE_ADS }"
>
    <div class="container">
        <div fxLayout="row wrap" class="col-gap">
            <ng-container *ngFor="let card of homePageDataCustomAds">
                <div
                    class="MyImage"
                    fxFlex.xs="{{
                        environmentVariables?.ADS_THEME_TYPE == 'horizontal'
                            ? 50
                            : 100
                    }}"
                    fxFlex.sm="{{
                        environmentVariables?.ADS_THEME_TYPE == 'horizontal'
                            ? 50
                            : 100
                    }}"
                    fxFlex.md="25"
                    fxFlex.lg="25"
                    fxFlex.xl="25"
                    *ngIf="card.active"
                >
                    <span
                        class="bannerCard"
                        [ngClass]="{ pointer: card?.type != 0 }"
                        (click)="bannerRouting(card)"
                    >
                        <span
                            class="overlay-bannar"
                            *ngIf="environmentVariables?.ENABLE_ADS_OVERLAY"
                        >
                            <span>
                                {{ card?.name }}
                            </span>
                        </span>
                        <a class="img-anchor">
                            <img  loading="lazy"  class="banner-img" [src]="card?.image_web" />
                        </a>
                    </span>
                </div>
            </ng-container>
        </div>
    </div>
</div> -->



<div *ngIf="active_customAds?.length > 0" >
<ng-container *ngIf="active_customAds?.length > 3 || environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE " >
  <div class="container pb-5 pt-2">
      <div class="swiper-container"
      [ngClass]="{'swiper-wrapper-config': !environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE && active_customAds?.length > 3 }"
      >
          <swiper [config]="SwiperConfig">
              <ng-template
                  swiperSlide
                  *ngFor="let ad of active_customAds; let i = index"
                  class="swiper-slide"
              >
                  <span 
                  class="bannerCard"
                   style="height:265px ; width: 265px; max-width: 265px;"
                  (click)="bannerRouting(ad, i)"
              >
                  <a class="img-anchor">
                      <img  loading="lazy"  class="web-view"  [src]="ad?.image_web"    [alt]="ad?.image_web" />
                  </a>
                  <a class="img-anchor">
                      <img  loading="lazy"  class="mob-view"  [src]="ad?.image"    [alt]="ad?.image" />
                  </a>
              </span>
              </ng-template>
          </swiper>
      </div>
  </div>
</ng-container>
</div>



<div *ngIf="active_customAds?.length > 0" >
<ng-container  *ngIf="!environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE && active_customAds?.length <= 3 ">
  <div class="multi-imgs-area d-flex container pb-5 pt-2">
   <ng-container *ngFor="let ad of active_customAds ; let i = index">
    <div class="single-img"  
    [ngClass]="ad.type != 0 ? 'pointer' : 'no-envent'" 
    >
      <img  loading="lazy" 
          [src]="ad?.image_web"
          class="web-view"
          onError="this.src='./../../../../assets/images/section/600x160.png';"
             [alt]="ad?.image_web"
          (click)="bannerRouting(ad, i)"
      />
      <img  loading="lazy" 
      [src]="ad?.image"
       class="mob-view"
       onError="this.src='./../../../../assets/images/section/600x160.png';"
          [alt]="ad?.image"
       (click)="bannerRouting(ad, i )"
   />
      </div>
      <div
    *ngIf="i + 1 < active_customAds?.length"
    class="devider"></div>
   </ng-container>
    
   
 
    

</div>
</ng-container>
</div>























<!-- Slider Show -->


<!-- <div
    class="section-gap pb-0 pt-5 image-group sliderView"
    *ngIf="environmentVariables?.GROUP_MOBILE_ADS"
>
    <div class="container">
        <div class="swiper-container">
            <swiper [config]="smallSwiperConfig" class="mySwiper" #newSwiper>
                <ng-template
                    swiperSlide
                    *ngFor="let card of homePageDataCustomAds"
                    class="swiper-slide"
                >
                    <span
                        class="bannerCard"
                        [ngClass]="{ pointer: card?.type != 0 }"
                        (click)="bannerRouting(card)"
                    >
                        <span
                            class="overlay-bannar"
                            *ngIf="environmentVariables?.ENABLE_ADS_OVERLAY"
                        >
                            <span>
                                {{ card?.name }}
                            </span>
                        </span>
                        <a class="img-anchor">
                            <img  loading="lazy"  class="banner-img" [src]="card?.image_web" />
                        </a>
                    </span>
                </ng-template>
            </swiper>
        </div>
    </div>
</div> -->
